import React, { useRef } from 'react';
import ReactModal from 'react-modal';
import { CloseOutlined, MessageOutlined } from '@ant-design/icons';
import { PublishedRecommendation } from './site-recommendation.service';
import './recommendations.css';

interface RecommendationDialogProps {
  recommendation: PublishedRecommendation | null;
  onClose: () => void;
}

const initials = (fullName: string): string =>
  fullName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');

const RecommendationDialog: React.FC<RecommendationDialogProps> = ({
  recommendation,
  onClose,
}) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <ReactModal
      isOpen={recommendation !== null}
      onRequestClose={onClose}
      onAfterOpen={() => closeButtonRef.current?.focus()}
      className="recommendation-dialog"
      overlayClassName="recommendation-dialog-overlay"
      bodyOpenClassName="recommendation-dialog-open"
      ariaHideApp={false}
      contentLabel={
        recommendation
          ? `Full recommendation from ${recommendation.fullName}`
          : 'Full recommendation'
      }
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      shouldReturnFocusAfterClose
    >
      {recommendation ? (
        <article className="recommendation-dialog__content">
          <header className="recommendation-dialog__header">
            <div>
              <MessageOutlined
                className="recommendation-dialog__quote"
                aria-hidden="true"
              />
              <h2>Recommendation From {recommendation.fullName}</h2>
            </div>
            <button
              ref={closeButtonRef}
              type="button"
              className="recommendation-dialog__close"
              onClick={onClose}
              aria-label="Close full recommendation"
            >
              <CloseOutlined aria-hidden="true" />
            </button>
          </header>

          <blockquote>{recommendation.testimonial}</blockquote>

          <footer className="recommendation-dialog__author">
            <span className="recommendation-card__avatar" aria-hidden="true">
              {initials(recommendation.fullName)}
            </span>
            <span className="recommendation-card__person">
              <strong>{recommendation.fullName}</strong>
              <small>{recommendation.currentPosition}</small>
              {recommendation.companyName ? (
                <small className="recommendation-card__company">
                  {recommendation.companyName}
                </small>
              ) : null}
            </span>
          </footer>
        </article>
      ) : null}
    </ReactModal>
  );
};

export default RecommendationDialog;
